import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var iconPath = 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z';
function CheckIcon(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 448 512",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false",
    "aria-label": "copy"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: iconPath
    })
  }));
}
export default CheckIcon;